import StudentFeedbackModal from './StudentFeedbackModal';

export default StudentFeedbackModal;
